import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';
import { priceFormatter } from '@noths/polaris-client-utils';
import * as styles from "./styles";
export var Price = function Price(_ref) {
  var amount = _ref.amount,
    className = _ref.className,
    currency = _ref.currency,
    testId = _ref.testId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'normal' : _ref$type;
  return /*#__PURE__*/React.createElement(_StyledP, {
    className: className,
    "data-testid": testId,
    $_css: [styles.price, type === 'sale' && styles.sale, type === 'previous' && styles.previous]
  }, type === 'sale' && /*#__PURE__*/React.createElement(_StyledSpan, null, "Sale price "), type === 'previous' && /*#__PURE__*/React.createElement(_StyledSpan2, null, "Regular price "), priceFormatter(currency, amount));
};
var _StyledP = _styled("p")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan = _styled2("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), visuallyHidden);
var _StyledSpan2 = /*#__PURE__*/_styled3("span").withConfig({
  displayName: "Price___StyledSpan2",
  componentId: "sc-2mz1ek-0"
})(["", ""], visuallyHidden);